/**
 * TEMPORARY edit-lock bypass — REMOVE once Damien grants edit on Customer Acquisition.
 *
 * Why it exists: Ioan and Fiona are `view` on Customer Acquisition, so PermissionGate
 * locks every Distribution write control (Assess, Reply, Register, Select to run,
 * Advance, Park, Drop) and the funnel cannot be tested. Operator decision (Ioan,
 * 2026-09-23): bypass the lock on Distribution now rather than wait for the grant.
 * Damien owns the area; this overrides his view-only setting for this ONE module.
 *
 * What it does NOT weaken:
 *  - Only `view` is raised to `edit`. No access (`none` / unknown) stays denied (I-1).
 *  - Only the modules listed below. Every other module keeps its real decision.
 *  - Writes still hit funnel-api, which authorises on its own ALLOWED_PRINCIPALS
 *    allow-list; anyone outside it still gets a 403.
 *
 * To revert: empty the set (or delete this file and its two call sites in
 * src/routes/ShellPage.tsx). Tracked on bug 3e30402f-c6c9-81a9-b293-cb0bd4a499d2.
 */
export const EDIT_LOCK_BYPASS: ReadonlySet<string> = new Set(["distribution"]);

export function effectiveDecision<T extends string | null | undefined>(
  moduleKey: string | null | undefined,
  permission: T,
): T | "edit" {
  if (permission === "view" && moduleKey && EDIT_LOCK_BYPASS.has(moduleKey)) return "edit";
  return permission;
}
